import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var createUpdatedTypologiesObj = function createUpdatedTypologiesObj(_typologiesSelected, _macroTypologyObj) {
  //Case 0: no typologies selected
  if (!_typologiesSelected.length) return null;
  var _typologiesIds = [];
  var _typologiesIdList = [];
  var _iterator = _createForOfIteratorHelper(_typologiesSelected),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      _typologiesIds.push(t.listingTypologyId);
      _typologiesIdList = [].concat(_toConsumableArray(_typologiesIdList), _toConsumableArray(t.typologyIdList));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var url = "";
  /* If we select just one typology, and it is not allTypologies, we set our url to its url */
  if (_typologiesSelected.length === 1 && !_typologiesSelected[0].allTypologies) {
    url = _typologiesSelected[0].url;
  }
  /* In any other case, we are dealing or with multiple typologies selected, or with allTypologies selected.
  *  In this case, we will set the macroTypology url
  *  */else url = _macroTypologyObj[_typologiesSelected[0].macroTypologyID].url;
  return {
    macroTypologyID: _typologiesSelected[0].macroTypologyID,
    url: url,
    listingTypologyId: _typologiesSelected[0].listingTypologyId,
    //We can have multiple typologies
    selectedListingTypologiesIDList: _typologiesIds,
    selectedTypologiesIDList: _typologiesIdList
  };
};
/*
* Gets the most specific typology by the given macroTypology.
* So, for example, the macroTypology 1 ('Residential') of the typology 18 ('trilocali') will return the typology
* with listingTypologyID 1, macroTypology 1 and with the shortest typologyIdList which is ('appartamenti')
* */
export var getSpecificTypologyId = function getSpecificTypologyId(macroTypologyId) {
  var listingTypologies = window["_options"].listingTypologies || [];
  var candidates = listingTypologies.filter(function (l) {
    return !l.filterName && !l.filterValue && l.typologyIdList.includes(macroTypologyId);
  });
  candidates.sort(function (a, b) {
    return a.typologyIdList.length < b.typologyIdList.length ? -1 : 1;
  });
  return !candidates.length ? null : candidates[0];
};